class MobileNav {
  constructor(element, options) {
    this.element = element;
    this.options = options;

    this.showButton = document.querySelector(this.options.selectorShow);
    this.closeButton = document.querySelector(this.options.selectorClose);
    this.mainContent = document.querySelectorAll(this.options.mainContentTag);

    // missing forEach on NodeList for IE11
    if (window.NodeList && !NodeList.prototype.forEach) {
      NodeList.prototype.forEach = Array.prototype.forEach;
    }

    if (this.showButton) {
      this.showButton.addEventListener('click', () => {
        this.show();
      });
      window.addEventListener('resize', () => {
        const width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

        if (width > 1440) {
          this.element.classList.toggle(this.options.classVisible, false);
          this.closeButton.classList.remove('mobile-nav__close--show');
          this.showButton.classList.add('mobile-nav-toggle--show');
          document.body.classList.toggle(this.options.bodyClassVisible, false);
        }
      });
    }

    this._hookCloseActions();
  }

  _hookCloseActions() {
    this.closeButton.addEventListener('click', () => {
      this.hide();
    });

    document.body.addEventListener('keydown', evt => {
      if (evt.which === 27) {
        evt.stopPropagation();
        this.hide();
      }
    });
  }

  show() {
    this.mainContent.forEach(item => {
      item.setAttribute('aria-hidden', true);
    });
    this.closeButton.classList.toggle('mobile-nav__close--show');
    this.showButton.classList.toggle('mobile-nav-toggle--show');
    this.element.classList.toggle(this.options.classVisible, true);
    document.body.classList.toggle(this.options.bodyClassVisible, true);
  }

  hide() {
    this.mainContent.forEach(item => {
      item.setAttribute('aria-hidden', false);
    });

    this.closeButton.classList.toggle('mobile-nav__close--show');
    this.showButton.classList.toggle('mobile-nav-toggle--show');
    this.element.classList.toggle(this.options.classVisible, false);
    document.body.classList.toggle(this.options.bodyClassVisible, false);
  }

  static create(element) {
    new this(element, this.options);
  }

  static init() {
    const element = document.querySelector('[data-mobile-nav]');
    this.create(element);
  }

  static options = {
    selectorInit: '[data-mobile-nav]',
    selectorShow: '[data-mobile-nav-show]',
    selectorClose: '[data-mobile-nav-close]',
    classVisible: 'is-visible',
    bodyClassVisible: 'mobile-nav-visible',
    mainContentTag: 'body > *:not(.mobile-nav)'
  };
}

export default MobileNav;
